import { Accordion, Card, Checkbox, Col, EventHandler, InputField, Label, OutlineButton, PrimaryButton, Quantity, ReactSelectBox, Row } from "client/CommonComponents";
import deleteOrder from '../../../../assets/images/Delete New.svg';
import './AssessmentQuestion.scss';
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup";
import permissions, { isAuthorized } from "client/utils/Permissions";

const AssessmentQuestion = (props:any) => {
    const { 
        questionTypes, 
        onChangeQuestion, 
        optionTypeOnChange, 
        onChangeOption, 
        onChangeOptionAnswer,
        onDeleteOption,
        onDeleteQuestion,
        handleCancelClick,
        assessmentTitle,
        isEditMode
       } = props

    const ExpandedItems:any = [];  

    props?.questionList.map((item:any, index: number)=>{
        return ExpandedItems.push(
            {
              headerText: (
                <div className="accordionHeader">
                    <p className="headingText pull-left">Question {index + 1}</p>
                    {!isEditMode && (
                        <EventHandler onEvent={() => onDeleteQuestion(item?.questionIndex)} data-attribute={`AssessmentQuestion_${(item?.questionIndex || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                            <img src={deleteOrder} alt='Delete Order' className='me-2 pull-right' />
                        </EventHandler>
                    )}
                </div>
              ),
              content: <>
              <Row>
              <Col xs={12} className='mb-md-3 mb-3'> 
                  <Label required data-attribute="AssessmentQuestion_Default_Label">Question</Label>
                  <InputField 
                  placeholder='Enter Question' 
                  value={item?.question} 
                  onChange={(e:any)=>onChangeQuestion(e?.target?.value, item?.questionIndex)}
                   data-attribute="AssessmentQuestion_Default_Input" />
                  {item?.questionError ? <p className='validMessage'>{item?.questionError}</p> : ""}
              </Col>
              <Col xs={12} sm={3} md={3} lg={3} xl={3} className='mb-md-3 mb-3'>
                  <Label required data-attribute="AssessmentQuestion_Default_Label_2">Option Type</Label>
                  <ReactSelectBox 
                      options={questionTypes}
                      onChange={(option: any, e: any) => optionTypeOnChange(e, option, item?.questionIndex)}
                      value={questionTypes?.find((i: any) => i.value === item?.optionType?.toString())}
                      className={props?.optionType?.value == "Select Option Type" ? 'controlValidation' : "" }
                   data-attribute="AssessmentQuestion_Default_SearchSelectBox" />
                  {item?.optionTypeError ? <p className='validMessage'>{item?.optionTypeError}</p> : ""}
              </Col>
              <Col xs={12} sm={4} md={5} lg={4} xl={3} className='mb-md-0 mb-3'>
                  <Label required data-attribute="AssessmentQuestion_Default_Label_3"># of Options</Label>
                          <div className="quantity-btn-block">
                              <div>
                                  <Quantity
                                      increment={() => props?.incrementQuantity(item?.questionIndex)}
                                      decrement={() => props?.decrementQuantity(item?.questionIndex)}
                                      value={item?.noOfOptions}
                                      disableFlg={(item?.noOfOptions < 2 || item?.noOfOptions === item?.options?.length) ? true : false}
                                      disabledQuantity={true}
                                      onChange={() => props?.onChangeQuantity(item?.questionIndex)}
                                   data-attribute="AssessmentQuestion_Default_Quantity" />
                                  {item?.noOfOptionsError ? <p className='validMessage'>{item?.noOfOptionsError}</p> : ""}
                              </div>
                      <PrimaryButton text='Add Answer Options' className='pull-right ms-3' onClick={() => props?.onClickAddAnswerBtn(item?.questionIndex)} data-attribute="AssessmentQuestion_Default_Button" />
                  </div>              
              </Col>      
          </Row>
          {
              props?.showAssessmentAnswer ? <Row>
                  <p className="description-text">Answer Options for the Question</p>
                  {
                      item?.options?.map((option:any, index: number)=>{                        
                          return(
                          <Col xs={12} sm={3} md={3} lg={3} xl={3} className='mb-3' key={option?.optionIndex}>
                              <div className="option-answer-block">
                                  <Label required data-attribute="AssessmentQuestion_Default_Label_4">Option {index + 1}</Label>
                                  <EventHandler onEvent={() => onDeleteOption(item?.questionIndex, option?.optionIndex)} data-attribute={`AssessmentQuestion_${(item?.questionIndex || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_${(option?.optionIndex || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Option_EventHandler`}>
                                      <img src={deleteOrder} alt='Delete Order' className='mb-2 pull-right' />
                                  </EventHandler>
                              </div>                  
                              <InputField placeholder={`Enter Option ${index + 1}`} onChange={(e:any)=>onChangeOption(e.target.value, item?.questionIndex, option?.optionIndex)} value={option?.optionValue} data-attribute="AssessmentQuestion_Default_Input_2" />
                              {option?.optionError ? <p className='validMessage'>{option?.optionError}</p> : ""}
                              <div className="correct-answer-block">
                                  <span>Correct Answer</span>
                                  <Checkbox className='pull-right mb-0' checked={option?.isAnswer} onChange={(e: any, value: boolean)=>onChangeOptionAnswer(value,item?.questionIndex, option?.optionIndex)} data-attribute="AssessmentQuestion_Default_Checkbox" />
                              </div>
                          </Col>
                          )
                      })
                  } 
                   {item?.answerOptionError ? <p className='validMessage'>{item?.answerOptionError}</p> : ""}             
              </Row> : '' 
          }
          </>,
              uuid: `Accordion${index + 1}`,
            },
        );
    })
    
    return(<div className="mt-sm-3">
        <Card data-attribute="AssessmentQuestion_Default_Card">
            <div className='header border-bottom-asset'>
                <p className='headingText mb-0'>{assessmentTitle}</p>
                <p className='subText'>Provide questions in detail</p>
            </div>
            <Accordion
                Items={ExpandedItems}
                preExpanded={['Accordion1']}
                className= {`assessment-question-accordion`}
             data-attribute="AssessmentQuestion_Default_Accordion" />
            <div>
                <PrimaryButton text='Submit' className='pull-right' onClick={props?.handleClickSubmit} disabled={!isAuthorized(permissions.CreateAssessment)} data-attribute="AssessmentQuestion_Default_Button_2" />
                <OutlineButton text='Cancel' className='pull-right' onClick={handleCancelClick} data-attribute="AssessmentQuestion_Default_Button_3" />
            </div>
            {props?.submitPopupcontent.isDialogVisible &&
                <CompleteConfirmationPopup
                    hideDialog={!props?.submitPopupcontent.isDialogVisible}
                    onDismiss={props?.hideDialogSubmit}
                    Popupcontent={props?.submitPopupcontent}
                    popupOutlinebtnOnclick={() => props?.submitPopupcontent.popupOutlinebtnOnclick()}
                    popupPrimarybtnOnclick={()=> props?.submitPopupcontent.popupPrimarybtnOnclick()}
                />
            }
        </Card>
    </div>     
    )
}

export default AssessmentQuestion;
